import { Component, OnInit } from '@angular/core';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { DatePipe } from '@angular/common';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  isbillsummaryreport: boolean = false;
  isopenbillreport: boolean = false;
  isbillcancelsummaryreport: boolean = false;
  isproductcancelreport: boolean = false;
  isbillcancelreport: boolean = false;
  isexpensereport: boolean = false;

  issalesxreport: boolean = false;
  isdinetypereport: boolean = false;
  isproductreport: boolean = false;
  isgroupreport: boolean = false;
  isdailyreport: boolean = false;
  isordermodereport: boolean = false;
  ispaymentmodereport: boolean = false;
  isdiscountreport: boolean = false;
  isbillwaisepaymentreport: boolean = false;
  isstationreport: boolean = false;
  issectionreport: boolean = false;
  istablereport: boolean = false;

  iscustomerreport: boolean = false;

  isloyaltyreport: boolean = false;
  iscomplimentoryreport: boolean = false;
  isfastmovingreport: boolean = false;
  isvariationreport: boolean = false;
  iswaiterreport: boolean = false;
  iscashierreport: boolean = false;
  ishourlysalesreport: boolean = false;

  istaxreport: boolean = false;
  issalesaudittrailreport: boolean = false;


  isaudittrailreport: boolean = false;
  isaccountsreport: boolean = false;

  isstockreport: boolean = false;
  ispurchasereport: boolean = false;
  isinventoryreport: boolean = false;

  isoutletwiseshiftclosereport:boolean=false
  isoutletwisenewcustomerreport:boolean=false
  isoutletwisecustomerfootfallreport:boolean=false

  isprivilage: boolean = false;

  isalloutletmenu: boolean = false;

  isaccounts:boolean=false

  constructor(private appService: DhukanDataService, private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private route: ActivatedRoute, private datePipe: DatePipe) {
    this.fnServiceChanges();
  }

  //User Check
  fnServiceChanges() {
    
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.ngOnInit();
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }

      if (this.loginService.fnCheckUser()) {
        

      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {

    this.fnCheckMenu();
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }

  fnCheckMenu() {

    this.isaccounts=this.loginService.isaccounts

    if (this.loginService.fnCheckUserRoleAction('BillSummaryReport', 'VIEW')) {
      this.isbillsummaryreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('OpenBillReport', 'VIEW')) {
      this.isopenbillreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('BillCancelReport', 'VIEW')) {
      this.isbillcancelsummaryreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('ProductCancelReport', 'VIEW')) {
      this.isproductcancelreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('BillCancelReport', 'VIEW')) {
      this.isbillcancelreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('ExpenseReport', 'VIEW')) {
      this.isexpensereport = true;
    }






    if (this.loginService.fnCheckUserRoleAction('SalesXReport', 'VIEW')) {
      this.issalesxreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('DinetypeReport', 'VIEW')) {
      this.isdinetypereport = true;
    }


    if (this.loginService.fnCheckUserRoleAction('ProductReport', 'VIEW')) {
      this.isproductreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('GroupReport', 'VIEW')) {
      this.isgroupreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('DailyReport', 'VIEW')) {
      this.isdailyreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('OrdermodeReport', 'VIEW')) {
      this.isordermodereport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('PaymentmodeReport', 'VIEW')) {
      this.ispaymentmodereport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('DiscountReport', 'VIEW')) {
      this.isdiscountreport = true;
    }


    if (this.loginService.fnCheckUserRoleAction('BillWisePaymentReport', 'VIEW')) {
      this.isbillwaisepaymentreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('StationwiseReport', 'VIEW')) {
      this.isstationreport = true;
    }


    if (this.loginService.fnCheckUserRoleAction('SectionReport', 'VIEW')) {
      this.issectionreport = true;
    }


    if (this.loginService.fnCheckUserRoleAction('TableReport', 'VIEW')) {
      this.istablereport = true;
    }



    if (this.loginService.fnCheckUserRoleAction('CustomerReport', 'VIEW')) {
      this.iscustomerreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('LoyaltyReport', 'VIEW')) {
      this.isloyaltyreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('ComplimentoryReport', 'VIEW')) {
      this.iscomplimentoryreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('FastmovingproductReport', 'VIEW')) {
      this.isfastmovingreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('VariationReport', 'VIEW')) {
      this.isvariationreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('WaiterReport', 'VIEW')) {
      this.iswaiterreport = true;
    }


    if (this.loginService.fnCheckUserRoleAction('CashierRepot', 'VIEW')) {
      this.iscashierreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('HourlysalesReport', 'VIEW')) {
      this.ishourlysalesreport = true;
    }


    if (this.loginService.fnCheckUserRoleAction('ActivitylogReport', 'VIEW')) {
      this.isaudittrailreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('TaxSummaryReport', 'VIEW')) {
      this.istaxreport = true;
    }


    
    if (this.loginService.fnCheckUserRoleAction('SalesActivitylogReport', 'VIEW')) {
      this.issalesaudittrailreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('StockReport', 'VIEW')) {
      this.isstockreport = true;
    }

    if (this.loginService.fnCheckUserRoleAction('PurchaseReport', 'VIEW')) {
      this.ispurchasereport = true;
    }

    
    if (this.loginService.fnCheckUserRoleAction('OutletWiseShiftCloseReport', 'VIEW')) {
      this.isoutletwiseshiftclosereport = true;
    }


    if (this.loginService.fnCheckUserRoleAction('OutletWiseNewCustomerReport', 'VIEW')) {
      this.isoutletwisenewcustomerreport = true;
    }


    if (this.loginService.fnCheckUserRoleAction('OutletWiseFootFallReport', 'VIEW')) {
      this.isoutletwisecustomerfootfallreport = true;
    }


    if (this.loginService.fnGetCompanyId() === 0) {
      this.isalloutletmenu = true
    }

    if(this.isstockreport===true || this.ispurchasereport===true){
      this.isinventoryreport=true
    }

    this.isaccountsreport=true;
  }

  fnRedirectReport(type) {
    try {

      this.router.navigate(['/Report/' + type]);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }

  }



  fnRedirectReportDirect(type) {
    try {

      this.router.navigate(['/' + type]);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }

  }
  fnReportHeaderClick(name) {
    var element = document.getElementById(name);

    // element.scrollIntoView();
    // element.scrollIntoView(false);
    // element.scrollIntoView({ block: "end" });
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
